export const DOCUMENT_LIMIT = 10;
export const DOCUMENT_NAME_MAX = 50;
export const MAX_PDF_SIZE_MB = 10;
export const ACCEPTED_PDF_TYPE = 'application/pdf';

export type DocumentsFieldsProps = {
  companyId: string;
};

export type SortableDocumentRowProps = {
  field: { id: string };
  index: number;
  onRemove: (index: number) => void;
  onDownload: (index: number) => Promise<void>;
  isDownloading: boolean;
};
